module.exports = __webpack_public_path__ + "img/submit_insurance_plan.1933dd27.png";